import React, { useRef, useEffect } from "react";
import { HexColorPicker } from "react-colorful";
import { PRESET_COLORS } from "./color-picker.type";
import {
  ColorPickerContainer,
  ColorPicker,
  ColorSwatches,
  ColorSwatch,
} from "./styled";

const ColorPickerPopup = ({
  currentColor,
  onColorChange,
  onClose,
}) => {
  const pickerRef = useRef(null);

  // Close when clicking outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (
        pickerRef.current &&
        !pickerRef.current.contains(event.target)
      ) {
        onClose();
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [onClose]);

  const handleSwatchClick = (color) => {
    console.log('[ColorPickerPopup] handleSwatchClick:', color);
    onColorChange(color);
    onClose();
  };

  return (
    <ColorPickerContainer
      ref={pickerRef}
      onMouseDown={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
    >
      <ColorPicker>
        <HexColorPicker 
          color={currentColor} 
          onChange={(color) => {
            console.log('[ColorPickerPopup] HexColorPicker onChange:', color);
            onColorChange(color);
          }} 
        />
        <ColorSwatches>
          {PRESET_COLORS.map((color) => (
            <ColorSwatch
              key={color}
              $color={color}
              onMouseDown={(e) => {
                e.preventDefault();
                e.stopPropagation();
              }}
              onClick={() => handleSwatchClick(color)}
              title={color}
            />
          ))}
        </ColorSwatches>
      </ColorPicker>
    </ColorPickerContainer>
  );
};

export default ColorPickerPopup;
